import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Chip from '@mui/joy/Chip';
import List from '@mui/joy/List';
import Tooltip from '@mui/joy/Tooltip';
import RequestListItem from './RequestListItem';

import { observer } from 'mobx-react-lite';

import useFHRequest from 'hooks/useFHRequest';
import useAuth from 'hooks/useAuth';

type RequestsPaneProps = {

};

function _RequestsPane({

}: RequestsPaneProps) {

    const { fetchListByUser, getListByUser } = useFHRequest();
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [requests, setRequests] = useState(getListByUser(currentUser.uuid));
    const [fetched, setFetched] = useState(false);
    const [cursor, setCursor] = useState('');
    const [fetching, setFetching] = useState(false);


    function doFetch() {
        setFetching(true);
        fetchListByUser(cursor)
            .then((cursor: string) => {
                console.log('fetched list, cursor:', cursor);
                    setCursor(cursor);
                console.log('actually fetched list');
                setRequests(
                    getListByUser(currentUser.uuid)
                    .sort((a, b) => {
                        return a.date_created > b.date_created ? -1 : 1;
                    })
                );
            })
            .finally(() => {
                setFetching(false);
            });
    }

    useEffect(() => {
        if(!currentUser?.uuid || fetched) {
            return;
        }
        doFetch();
        setFetched(true);
    }, [currentUser.uuid, setRequests]);


	return (
		<Stack
            m={1}
			sx={{
				// borderRight: '1px solid',
				// borderLeft: '1px solid',
				// borderColor: 'divider',
				overflowAnchor: 'none',
				display: 'flex',
				flexGrow: 1,
				flexDirection: 'column',
				flexShrink: 1,
			}}
        >
            <Stack
                sx={{ borderBottom: '1px solid', borderColor: 'divider' }}
                justifyContent="space-between"
                alignItems="center"
                pr={1}
                direction="row">
            <Stack
                spacing={0}
                p={2}
                pb={1.5}

            >

                <Typography
                    fontSize={{ xs: 'md', md: 'lg' }}
                    fontWeight="lg"
                    endDecorator={
                        <Chip
                            variant="outlined"
                            color="neutral"
                            size="sm"
                            slotProps={{ root: { component: 'span' } }}
                        >
                            {requests.length}
                        </Chip>
                    }
                    sx={{ mr: 'auto' }}
                >
                    Request List
                </Typography>
                <Tooltip arrow title="Some of these may be part of a project too">
                <Typography level="body-xs">
                    These are your standard requests.
                </Typography>
                </Tooltip>
            </Stack>

                <Stack>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="sm"
                        onClick={() => {
                            navigate('/requests/new');
                            // console.log('clicked');
                        }}>New</Button>
                </Stack>
            </Stack>

			<List
				sx={{

					overflowY: 'auto',
					overflowX: 'hidden',

					py: 0,
					'--ListItem-paddingY': '0.75rem',
					'--ListItem-paddingX': '1rem',
				}}

			>
				{requests.map((request) => (
					<RequestListItem
						key={request.key}
						request={request}
					/>
				))}
                { cursor &&
                    <Stack
                        justifyContent="center"
                        direction="row"
                        m={2}>
                        <Button
                                  variant="plain"
                        loading={fetching}
                        onClick={() => doFetch()}>
                        Load More Requests
                    </Button>
                    </Stack>
                 }
			</List>
		</Stack>
	);
}

const cp = observer(_RequestsPane);
export default cp;
